import { LitElement, html } from "@lit"

class MobileMenuPanel extends LitElement {
  static properties = {
    isOpen: { type: Boolean, reflect: true, attribute: 'is-open' },
  }

  constructor() {
    super()
    this.isOpen = false
    this.focusableElements = []

    this._handleSubMenuOpen = this._handleSubMenuOpen.bind(this)
    this._handleSubMenuClose = this._handleSubMenuClose.bind(this)
  }

  connectedCallback() {
    super.connectedCallback()

    this.$container = this.querySelector(".mobile-menu__container")
    this.parentItems = this.querySelectorAll(".js-mobile-parent-item")
    this.subPanels = this.querySelectorAll(".mobile-menu__sub-panel")
    this.closeSubpanelBtn = this.querySelector(".js-submenu-close-button")

    for (const item of this.parentItems) {
      item.addEventListener("click", this._handleSubMenuOpen)
    }

    this.closeSubpanelBtn?.addEventListener("click", this._handleSubMenuClose)
  }

  disconnectedCallback() {
    super.disconnectedCallback()

    for (const item of this.parentItems) {
      item.removeEventListener("click", this._handleSubMenuOpen)
    }

    this.closeSubpanelBtn?.removeEventListener("click", this._handleSubMenuClose)
  }

  firstUpdated() {
    this.focusableElements = [
      ...this.querySelectorAll('a[href], button, sl-details, sl-button, [tabindex]')
    ]

    if (this.isOpen) {
      this._updateElementFocusability('landing')
    } else {
      this._resetElementFocusability()
    }
  }

  updated(changedProperties) {
    if (changedProperties.has('isOpen')) {
      if (this.isOpen) {
        this._updateElementFocusability('landing')
      } else {
        this._resetElementFocusability()
      }
    }
  }

  _handleSubMenuOpen(e) {
    e.preventDefault()

    const targetId = e.target?.getAttribute("data-target") || ""
    if (targetId) {
      for (const item of this.subPanels) {
        const panelId = item.getAttribute("data-panel-id")
        if (panelId === targetId) {
          item.classList.remove("transparent")
          this._updateElementFocusability(item)
        } else {
          item.classList.add("transparent")
        }
      }
    }

    this.$container.classList.add("mobile-submenu__opened")
  }

  _handleSubMenuClose() {
    this.$container.classList.remove("mobile-submenu__opened")

    for (const item of this.subPanels) {
      item.classList.add("transparent")
    }

    this._updateElementFocusability('landing')
  }

  _updateElementFocusability(level) {
    for (const element of this.focusableElements) {
      let isFocusable = false

      if (typeof level === 'string' && level === 'landing') {
        isFocusable = !!element.closest('.mobile-menu__landing')
      } else if (typeof level !== 'string' && level instanceof HTMLElement) {
        isFocusable = !!element.closest(`[data-panel-id="${level.getAttribute('data-panel-id')}"]`) || !!element.closest('.mobile-menu__top')
      }

      element.setAttribute('tabindex', isFocusable ? '0' : '-1')
      if (element.tagName === 'SL-DRAWER' || element.tagName === 'SL-DETAILS') {
        if (isFocusable) {
          element.removeAttribute('inert');
        } else {
          element.setAttribute('inert', '');
        }
      }
    }
  }

  _resetElementFocusability() {
    for (const element of this.focusableElements) {
      element.setAttribute('tabindex', '0')
      element.removeAttribute('inert');
    }
  }

  render() {
    return html`<slot></slot>`
  }
}

customElements.define("mobile-menu-panel", MobileMenuPanel)
